import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const PublicFacilityContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8002';

const extractSlug = (hostname) => {
  if (!hostname) return null;
  if (hostname === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) return null;
  const parts = hostname.split('.');
  if (parts.length < 3) return null;
  const sub = parts[0];
  if (sub === 'www' || sub === 'app') return null;
  return sub;
};

export const PublicFacilityProvider = ({ children }) => {
  const [facility, setFacility] = useState(null);
  const [slug, setSlug] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const detectedSlug = extractSlug(window.location.hostname);
    if (!detectedSlug) {
      setLoading(false);
      return;
    }
    setSlug(detectedSlug);

    axios
      .get(`${API_URL}/api/website/by-slug/${detectedSlug}`)
      .then((res) => {
        setFacility(res.data);
      })
      .catch((err) => {
        setError(err.response?.status === 404 ? 'facility_not_found' : 'network_error');
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <PublicFacilityContext.Provider value={{ facility, slug, loading, error }}>
      {children}
    </PublicFacilityContext.Provider>
  );
};

export const usePublicFacility = () => {
  const ctx = useContext(PublicFacilityContext);
  if (!ctx) throw new Error('usePublicFacility must be used within a PublicFacilityProvider');
  return ctx;
};

export default PublicFacilityContext;
